module.exports = __webpack_public_path__ + "img/智驹首页导航工程机小图.fafb2cfb.jpg";